import { useQuery } from '@tanstack/react-query';
import {
  getOrgSoftwareConfig,
  type OrgSoftwareConfig,
} from '@/services/org/org-software-config';

export const orgSoftwareConfigQueryKey = (orgId: string | undefined) => [
  'org-software-config',
  orgId,
];

export const useOrgSoftwareConfig = (orgId: string | undefined) =>
  useQuery<OrgSoftwareConfig, Error>({
    queryKey: orgSoftwareConfigQueryKey(orgId),
    queryFn: () => getOrgSoftwareConfig(orgId as string),
    enabled: !!orgId,
    retry: false,
  });
